import firebase from 'firebase/compat/app';
import admin from 'firebase-admin';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

const config = {
    apiKey: "AIzaSyDQ-ffWkus5gPo40GP1HLsB0ffJdNyeXzE",
    authDomain: "globalbrain-ba498.firebaseapp.com",
    databaseURL: "https://globalbrain-ba498.firebaseio.com",
    projectId: "globalbrain-ba498",
    storageBucket: "globalbrain-ba498.appspot.com",
    messagingSenderId: "990226424134",
    appId: "1:990226424134:web:32c773bf29a1f28a0b8547"
};

// export const firebaseImpl = firebase.initializeApp(config);
// export const firebaseDatabase = firebase.database();
firebase.initializeApp(config);
export const firebaseFire = firebase.firestore();
export const firebaseStorage = firebase.storage();
export const firebaseAuth = firebase.auth()
// export const fireAdminAuth = firebase.auth();
